import { Directive, ElementRef, OnDestroy, output } from '@angular/core';

@Directive({
  selector: '[elementResize]', // El nombre que usaremos en el HTML
  standalone: true // Para poder importarla directamente
})
export class ElementResizeDirective implements OnDestroy {
  resize = output<number>({ alias: 'elementResize' });

  private observer: ResizeObserver;

  constructor(private el: ElementRef) {
    this.observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        // contentRect.height es lo más preciso para observadores
        this.resize.emit(entry.target.clientHeight);
      }
    });

    // Empezamos a observar el elemento donde pongamos la directiva
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
